import { shouldShowCWQALog } from "../../../utils/shouldShowCWQALog";

interface CWSegmentParams {
  cwSegment: {
    ab_test_name: string;
    ab_test_variant: string;
  };
}

export const useCWsegmentEvent = ({ cwSegment }: CWSegmentParams): void => {
  const eventData = {
    segment: cwSegment.ab_test_name,
    ab_test: cwSegment.ab_test_variant,
  };

  shouldShowCWQALog() && console.log(`cw_segment_event`, eventData);
  window.gtag("event", "cw_segment", eventData);
};